import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/freezeLifecycleSagas";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.freezeLifecycle.rangeOptions);
  const selected = useSelector((state) => state.freezeLifecycle.selectedFilters.rangeOption);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selected}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
